import { useAuth } from './AuthProvider';
import { DENIAL_MESSAGES } from './access';

export function SignInPage() {
  const { signInWithGoogle } = useAuth();
  return (
    <main className="foundation-page">
      <section className="foundation-card" aria-labelledby="signin-title">
        <p className="eyebrow">TAP Creative Operations Hub</p>
        <h1 id="signin-title">Sign in</h1>
        <p className="lede">Access requires an approved account or a valid invitation.</p>
        <button
          type="button"
          className="ui-button ui-button--primary ui-button--md"
          onClick={() => {
            void signInWithGoogle();
          }}
        >
          Continue with Google
        </button>
      </section>
    </main>
  );
}

export function AuthCallbackPage() {
  return (
    <main className="foundation-page">
      <section className="foundation-card" aria-labelledby="callback-title">
        <h1 id="callback-title">Signing you in…</h1>
        <p className="lede" role="status">
          Completing Google sign-in and checking your access.
        </p>
      </section>
    </main>
  );
}

export function LoadingPage() {
  return (
    <main className="foundation-page">
      <section className="foundation-card" aria-labelledby="loading-title">
        <h1 id="loading-title">Loading</h1>
        <p className="lede" role="status">
          Checking your session…
        </p>
      </section>
    </main>
  );
}

export function AccessDeniedPage({ reason }: { reason: keyof typeof DENIAL_MESSAGES }) {
  const { signOut } = useAuth();
  return (
    <main className="foundation-page">
      <section className="foundation-card" aria-labelledby="denied-title">
        <p className="eyebrow">TAP Creative Operations Hub</p>
        <h1 id="denied-title">Access denied</h1>
        <p className="lede">{DENIAL_MESSAGES[reason]}</p>
        <button
          type="button"
          className="ui-button ui-button--primary ui-button--md"
          onClick={() => {
            void signOut();
          }}
        >
          Sign out
        </button>
      </section>
    </main>
  );
}
